export const FormStyle =
  " w-full  rounded py-3 px-[14px] placeholder:text-sm text-body-color text-base border border-[f0f0f0] outline-none focus-visible:shadow-none focus:border-primary ";
